// Stage 90: Parallax Module — frontend API client + type re-declarations.
//
// Types are DELIBERATELY duplicated rather than imported from the worker.
// The cross-package air gap is duplication, mirroring the pattern Memory /
// Homunculus / Phantom / Gadfly use. See stage90-parallax-module-integration-plan.md §28.
//
// IMPORTANT: scripts/verify-parallax-boundaries.cjs asserts that
// frontend/src/components/ChatTranscript.tsx never imports this module.
// rawParallaxMd must never reach end users in the chat — it is
// operator-only diagnostic content (TINS §Implementation Notes #4).

import { apiGet } from './client';

export type CupState = 'QUIET' | 'SPLASH';
export type ParallaxMode = 'cup' | 'trajectory';

export interface Anchor {
  text: string;
  source: 'mood-pool';
}

export interface CupReadResult {
  cupReadId: string;
  cupState: CupState;
  splashAnchor: string | null;
  splashDirection: string | null;
  anchorsUsed: Anchor[];
  trajectoryWindowTurns: number;
  moodLabel: string;
  rawParallaxMd: string;
  generatedAt: string;
  durationMs: number;
  modelUsed: string;
  mode: ParallaxMode;
  trajectorySummary: string | null;
  failed: boolean;
  failureReason: string | null;
}

export interface CupSlot {
  conversationId: string;
  personaSeedHex: string;
  moodLabel: string;
  result: CupReadResult;
  blockText: string;
}

export interface ParallaxHealth {
  ok: boolean;
  service: string;
  version: string;
  enabled: boolean;
  model: string;
  modelConfigured: boolean;
  apiKeyConfigured: boolean;
  region: string;
  timestamp: string;
}

/** GET /api/parallax/healthcheck — public, no auth. */
export const parallaxHealthcheck = () =>
  apiGet<ParallaxHealth>('/api/parallax/healthcheck');

/** GET /api/parallax/current-slot — admin-only. */
export const parallaxCurrentSlot = (conversationId: string) =>
  apiGet<{ slot: CupSlot | null }>(
    `/api/parallax/current-slot?conversationId=${encodeURIComponent(conversationId)}`,
  );
